import { Animation } from "./animation.model";

export class Product{  
    constructor(JSONString){
        let parsedJSON = JSON.parse(JSONString);
        this.name = parsedJSON.name;
        this.animations = [];
        this.cameraLockedRef = null;
        this.introText = parsedJSON.intro;
        this.introImage = parsedJSON.image;

        this.currentAnimation = null;
        this.currentStep = null;
        this.root = null;
        this.rootMeshes = null;
        this.uiElementsRef = null;
        this.isResetting = true;
    }

    stopAnimation(){
        this.root.animationGroups.forEach(function (animationGroup) {
            animationGroup.stop();
        });
    }
    
    updateCurrentStep(){
        this.hideControls(); 
        if(this.animations[this.currentAnimation].steps.length==1 && this.currentStep == 0){
            this.playAnimation(
                this.animations[this.currentAnimation].steps[this.currentStep].start,
                this.animations[this.currentAnimation].steps[this.currentStep].end);
            this.currentStep++;
        }else if(this.currentStep < (this.animations[this.currentAnimation].steps.length)){
            this.displayNextStep();
            /*this.uiElementsRef.popUp.setPopUpVisibility(true);
            this.uiElementsRef.popUp.updatePopUp(
                this.animations[this.currentAnimation].steps[this.currentStep].image,
                this.animations[this.currentAnimation].steps[this.currentStep].description); */
        }else if(this.currentStep == (this.animations[this.currentAnimation].steps.length) && this.currentStep != 1){
            this.uiElementsRef.joystickLeft.setJoystickVisibility(false);
            this.uiElementsRef.joystickRight.setJoystickVisibility(false);
            this.uiElementsRef.imageControlPanel.isVisible = false;
            this.uiElementsRef.gridControlPanel.isVisible = false;
            //this.playAnimation(this.animations[this.currentAnimation].steps[this.currentStep-1].start,this.animations[this.currentAnimation].steps[this.currentStep-1].end); 
            this.uiElementsRef.imageProcedureComplete.isVisible = true;
            this.uiElementsRef.panelTextBoxBoundary.isVisible = false;
            this.currentStep++;
        }
    }

    continueUpdateCurrentStep(){
        if(this.animations[this.currentAnimation].steps[this.currentStep].method=="joystickLeft"){
            this.uiElementsRef.joystickLeft.setActiveArrow(this.animations[this.currentAnimation].steps[this.currentStep].direction);
            this.uiElementsRef.joystickRight.setActiveArrow();
        }
        else if(this.animations[this.currentAnimation].steps[this.currentStep].method=="joystickRight"){
            this.uiElementsRef.joystickRight.setActiveArrow(this.animations[this.currentAnimation].steps[this.currentStep].direction);
            this.uiElementsRef.joystickLeft.setActiveArrow();
        }
        this.uiElementsRef.textStepDescription.text = this.animations[this.currentAnimation].steps[this.currentStep].description;
        if(this.uiElementsRef.textStepDescription.text == "Description not found"){
            this.uiElementsRef.textStepDescription.isVisible = false;
            this.uiElementsRef.panelTextBoxBoundary.isVisible = false;
            this.playAnimation(this.animations[this.currentAnimation].steps[this.currentStep].start,this.animations[this.currentAnimation].steps[this.currentStep].end);
        }else{
            this.uiElementsRef.textStepDescription.isVisible = true;
            this.uiElementsRef.panelTextBoxBoundary.isVisible = true;
            this.setCurrentAnimationFrame(this.animations[this.currentAnimation].steps[this.currentStep].start);
        }

        if(this.animations[this.currentAnimation].steps[this.currentStep].method=="joystickLeft"||this.animations[this.currentAnimation].steps[this.currentStep].method=="joystickRight"){
            this.uiElementsRef.joystickLeft.setJoystickVisibility(true);
            this.uiElementsRef.joystickRight.setJoystickVisibility(true);
        }else{
            this.uiElementsRef.joystickLeft.setJoystickVisibility(false);
            this.uiElementsRef.joystickRight.setJoystickVisibility(false);
        }

        if(this.animations[this.currentAnimation].steps[this.currentStep].method=="controlPanel"){
            this.uiElementsRef.imageControlPanel.isVisible = true;
            this.uiElementsRef.gridControlPanel.isVisible = true;
        }else{
            this.uiElementsRef.imageControlPanel.isVisible = false;
            this.uiElementsRef.gridControlPanel.isVisible = false;
        }

        if(this.currentStep-1 > -1){
            this.playAnimation(this.animations[this.currentAnimation].steps[this.currentStep-1].start,this.animations[this.currentAnimation].steps[this.currentStep-1].end);
            this.hideControls(); 
        } 
    }

    displayNextStep(){
        if(this.animations[this.currentAnimation].steps[this.currentStep].method=="joystickLeft"||this.animations[this.currentAnimation].steps[this.currentStep].method=="joystickRight"){
            this.uiElementsRef.joystickLeft.setJoystickVisibility(true);
            this.uiElementsRef.joystickRight.setJoystickVisibility(true);
        }
        if(this.animations[this.currentAnimation].steps[this.currentStep].method=="controlPanel"){
            this.uiElementsRef.imageControlPanel.isVisible = true;
            this.uiElementsRef.gridControlPanel.isVisible = true;
        }
        if(this.animations[this.currentAnimation].steps[this.currentStep].method=="joystickLeft"){
            this.uiElementsRef.joystickLeft.setActiveArrow(this.animations[this.currentAnimation].steps[this.currentStep].direction);
            this.uiElementsRef.joystickRight.setActiveArrow();
        }
        else if(this.animations[this.currentAnimation].steps[this.currentStep].method=="joystickRight"){
            this.uiElementsRef.joystickRight.setActiveArrow(this.animations[this.currentAnimation].steps[this.currentStep].direction); 
            this.uiElementsRef.joystickLeft.setActiveArrow();
        }
        this.uiElementsRef.textStepDescription.text = this.animations[this.currentAnimation].steps[this.currentStep].description;
        this.uiElementsRef.textStepDescription.isVisible = true;
        this.uiElementsRef.panelTextBoxBoundary.isVisible = true;
    }

    setCurrentAnimationFrame(frame){
        this.isResetting = true;
        this.root.animationGroups.forEach(function (animationGroup) {
            animationGroup.play();
            animationGroup.goToFrame(frame/30,0);
            animationGroup.stop();
        }); 
        this.isResetting = false;
    }

    updateCurrentAnimation(value){
        this.currentAnimation = value;
        this.currentStep = 0;
        this.setCurrentAnimationFrame(this.animations[this.currentAnimation].steps[this.currentStep].start);
        this.updateCurrentStep();
    }
    
    playAnimation(startFrame, endFrame){
        this.root.animationGroups.forEach(function (animationGroup) {
            animationGroup.start(false, 0.3, startFrame / 30, endFrame / 30); 
        }); 
        
    }

    hideControls(){
        this.uiElementsRef.imageControlPanel.isVisible = false;
        this.uiElementsRef.gridControlPanel.isVisible = false;
        this.uiElementsRef.joystickLeft.setJoystickVisibility(false);
        this.uiElementsRef.joystickRight.setJoystickVisibility(false);
        this.uiElementsRef.textStepDescription.isVisible = false;
        this.uiElementsRef.panelTextBoxBoundary.isVisible = false;
    }

    toggleMeshesVisibility(){
        if(this.rootMeshes[0].isVisible){
            this.rootMeshes[0].isVisible = false;
            for (var mesh of this.rootMeshes){
                mesh.setEnabled(false); 
            }  
        }else{
            this.rootMeshes[0].isVisible = true;  
            for (var mesh of this.rootMeshes){
                mesh.setEnabled(true); 
            }
        }  
    }

    focusCameraOnPart(cameraRef, partID){
        for(var i = 0; i<rootMeshes.length;i++){
            if(rootMeshes[i].id.includes(partID)){
                cameraRef.target = newModel.meshes[i].absolutePosition;
                cameraRef.radius = 1;
            }    
        } 
    }

    checkJoystickInput(joystickID){
        var side = null;
        var direction = null;

        if(joystickID.includes("leftJoystick"))
            side = "Left";
        else if(joystickID.includes("rightJoystick"))
            side = "Right";

        if(joystickID.includes("Arrowleft"))
            direction = "left";
        else if(joystickID.includes("Arrowright"))
            direction = "right";
        else if(joystickID.includes("Arrowup"))
            direction = "up";
        else if(joystickID.includes("Arrowdown"))
            direction = "down";

        console.log(joystickID);
        if(side != null && direction != null){
            if(this.animations[this.currentAnimation].steps[this.currentStep].method.includes("joystick"+side)){
                if(this.animations[this.currentAnimation].steps[this.currentStep].direction.includes(direction)){
                    this.currentStep++;
                    this.playAnimation(this.animations[this.currentAnimation].steps[this.currentStep-1].start,this.animations[this.currentAnimation].steps[this.currentStep-1].end);
                    this.hideControls(); 
                    //this.updateCurrentStep();
                }
            }
        }
    }

    checkControlPanelInput(controlPanelButtonID){
        var button = null;

        if(controlPanelButtonID.includes("power"))
            button = "power";
        else if(controlPanelButtonID.includes("control"))
            button = "control";

        console.log(controlPanelButtonID);
        if(button != null){
            if(this.animations[this.currentAnimation].steps[this.currentStep].method.includes("controlPanel")){
                if(this.animations[this.currentAnimation].steps[this.currentStep].button.includes(button)){
                    this.currentStep++;
                    this.playAnimation(this.animations[this.currentAnimation].steps[this.currentStep-1].start,this.animations[this.currentAnimation].steps[this.currentStep-1].end);
                    this.hideControls();
                    
                    //this.updateCurrentStep();
                }
            }
        }
    }
}